export default {
	routes:
	{
		frontpage:
		{
			menu: "Forside",
			path: ""
		},
		features:
		{
			menu: "Features",
			path: "Features"
		},
		about:
		{
			menu: "Om Skolefoto",
			path: "OmSkolefoto"
		},
		prices:
		{
			menu: "Priser",
			path: "Priser"
		},
		parents:
		{
			menu: "Forældre",
			path: "Foraeldre"
		},
		institutions:
		{
			menu: "Institutioner",
			path: "Institutioner"
		},
		terms:
		{
			menu: "Handelsbetingelser",
			path: "Handelsbetingelser"
		},
		privacypolicy:
		{
			menu: "Privatlivs politk",
			path: "PrivatlivsPolitik"
		},
		cookies:
		{
			menu: "Cookies",
			path: "Cookies"
		},
		datasafety:
		{
			menu: "Datasikkerhed og GDPR",
			path: "Datasikkerhed"
		},
		contact:
		{
			menu: "Kontakt",
			path: "Kontakt"
		}
	},
	header:
	{
		login: "Log ind"
	},
	footer:
	{
		support: "Support",
		supportemail: "info@skolefoto.net"
	}
}
